export const FETCH_PROFILE_SUCCESS = "FETCH_PROFILE_SUCCESS";
export const FETCH_PROFILE_REQUEST = "FETCH_PROFILE_REQUEST";
export const FETCH_PROFILE_FAILURE = "FETCH_PROFILE_FAILURE";
export const FETCH_PROFILE_RESET = "FETCH_PROFILE_RESET";
export const fetchProfileSuccess = (payload) => ({
    type: FETCH_PROFILE_SUCCESS,
    payload,
});
export const fetchProfileRequest = (payload) => ({
    type: FETCH_PROFILE_REQUEST,
    payload,
});
export const fetchProfileFailure = (payload) => ({
    type: FETCH_PROFILE_FAILURE,
    payload,
});
export const fetchProfileReset = () => ({
    type: FETCH_PROFILE_RESET,
});
